import {useState} from "react";
import styles from "@styles/pages/recipes/index.module.scss";
import * as React from "react";
import SIInput from "@components/input/si-input";
import SILink from "@components/link/silink";
import {MultiSelect} from "react-multi-select-component";
import Link from "next/link";
import qs from "qs";
import {strapi} from "@api/Strapi";

// @ts-ignore
function Recipes({recipeList, featuredRecipe, searchValue, currentPage, showMore, mealType = '', recipeType = ''}) {


    /**
     * Drop down mean type list
     */
    const optionsMealType = [
        {label: "entrees", value: "entrees"},
        {label: "small plates", value: "small_plates"},
        {label: "lunch", value: "lunch"},
        {label: "drinks", value: "drinks"},
        {label: "sweet", value: "sweet"},
        {label: "sweet dish", value: "sweet_dish"},
        {label: "main course", value: "main_course"},
        {label: "beverage", value: "beverage"},
        {label: "dessert", value: "dessert"},
        {label: "breakfast", value: "breakfast"},
        {label: "dip and dressing", value: "dip_and_dressing"},
    ];

    /**
     * Drop down recipe type list
     */
    const optionsRecipeType = [
        {label: "easy", value: "easy"},
        {label: "breakfast", value: "breakfast"},
        {label: "dinner", value: "dinner"},
        {label: "lunch", value: "lunch"},
        {label: "medium", value: "medium"},
        {label: "sweet", value: "sweet"},
        {label: "seasonal", value: "seasonal"},
        {label: "vegetarian", value: "vegetarian"},
        {label: "gluten -free", value: "gluten_free"},
        {label: "30 min or less", value: "30_min_or_less"},
    ]

    /**
     * Mean type selected item list
     */
    const [selectedMealType, setSelectedMealType] = useState(optionsMealType.filter((item: any) => {
        return mealType.split(",").indexOf(item.value) > -1
    }));

    /**
     * Recipe type selected item list
     */

    const [selectedRecipeType, setSelectedRecipeType] = useState(optionsRecipeType.filter((item: any) => {
        return recipeType.split(",").indexOf(item.value) > -1
    }));

    /**
     * On change of dropdown set title of the main button of meal type
     * @param selected
     * @param _options
     */
    const customValueRendererMealType = (selected: any, _options: any) => {
        return "meal types"
    };

    /**
     * On change of dropdown set title of the main button of recipe type
     * @param selected
     * @param _options
     */
    const customValueRendererRecipeType = (selected: any, _options: any) => {
        return "recipe types"
    };

    /**
     * email is used for store the value of the email input.
     */
    const [search, setSearch] = useState(searchValue ?? '');

    /**
     * This page contain header and footer components
     * The top section is banner where we show basic details
     * in body section we have search and dropdowns for filter
     * and also showing list of recipes
     */
    return (
        <>
            <section className={styles.banner}>
                <div className={'details_container'}>
                    <div className={'sidr_text'}>sidr</div>
                    <div className={'title_text'}>recipes</div>
                    <div className={'description'}>
                        Like us, you serve what you believe in. Make your favorite SIDR® honey your secret ingredient
                        for crafting everything delicious—from salad dressings and decadent desserts, to breakfast
                        smoothies and drinks.
                    </div>
                </div>
            </section>
            <section className={styles.container}>
                <div className={'top_bar'}>
                    <div className={'inner_box'}>
                        <SIInput placeholder={'SEARCH FOR RECIPES'} value={search} type={'text'} onChange={(e: any) => {
                            setSearch(e.currentTarget.value);
                        }}>
                        </SIInput>
                        <button onClick={() => {
                            let selectedMealTypeValues = selectedMealType.map((item: any) => {
                                return item.value
                            });
                            let selectedRecipeTypeValues = selectedRecipeType.map((item: any) => {
                                return item.value
                            });

                            let queryParam = qs.parse(window.location.search, {ignoreQueryPrefix: true});
                            queryParam.searchKeywords = search;
                            queryParam.mealType = selectedMealTypeValues.join(",");
                            queryParam.recipeType = selectedRecipeTypeValues.join(",");
                            window.location.href = `${window.location.pathname}?${qs.stringify(queryParam)}`;
                        }}><img alt={'search'}
                                src={'/assets/images/decorations/recipe_general/recipe_main_search_for_recipes_arrow.webp'}/>
                        </button>
                    </div>
                    <div className={'inner_box_select'}>
                        <MultiSelect hasSelectAll={false} disableSearch={true}
                                     options={optionsMealType}
                                     value={selectedMealType}
                                     onChange={setSelectedMealType}
                                     labelledBy="meal_types"
                                     valueRenderer={customValueRendererMealType}
                                     overrideStrings={{
                                         "selectSomeItems": "meal types",
                                     }}
                        />
                        <MultiSelect hasSelectAll={false} disableSearch={true}
                                     options={optionsRecipeType}
                                     value={selectedRecipeType}
                                     onChange={setSelectedRecipeType}
                                     labelledBy="recipe_types"
                                     valueRenderer={customValueRendererRecipeType}
                                     overrideStrings={{
                                         "selectSomeItems": "recipe types",
                                     }}
                        />
                    </div>
                </div>
                {
                    featuredRecipe &&
                    <Link className={'featured'}
                          href={`/recipes/${featuredRecipe.Link}`}>
                        <div className={'featured_box'}>
                            <img src={featuredRecipe.Small_Image.data.attributes.url}
                                 alt={featuredRecipe.Small_Image.data.attributes.alternativeText}/>
                        </div>
                        <div className={'featured_box'}>
                            <div className={'details'}>
                                <h1>featured</h1>
                                <h2>{featuredRecipe.Banner_Title}</h2>
                                <h1>{featuredRecipe.Recipes_Info.Dish}</h1>
                            </div>
                        </div>
                    </Link>
                }
                <div className={'receipes_line'}>
                    <hr/>
                    <h1>top recipes</h1>
                    <hr/>
                </div>
                <div className={'receipes'}>
                    <div className={'container'}>
                        {
                            recipeList.map((item: any, index: number) => {
                                return (<a href={`/recipes/${item.attributes.Link}`} key={'recepies-' + index}>
                                    <div className={'img_container'}>
                                        <img
                                            src={item.attributes.Small_Image.data.attributes.url}
                                            alt={item.attributes.Small_Image.data.attributes.alternativeText}/>
                                        <div/>
                                    </div>
                                    <div className={'title_tags'}>
                                        <span className={'tags'}>{item.attributes.Categories.join("/")}</span>
                                        <span>{item.attributes.Banner_Title}</span>
                                    </div>
                                </a>)
                            })
                        }
                        {
                            recipeList.length == 0 &&// eslint-disable-next-line react/no-unescaped-entities
                            <p>Sorry we weren’t able to find any results for "{search}"</p>

                        }
                    </div>
                    {
                        showMore ?
                            <div className={'show_more'}>
                                <SILink classes={''} href={'#!'} onClick={() => {
                                    currentPage = currentPage + 1;
                                    let queryParam = qs.parse(window.location.search, {ignoreQueryPrefix: true});
                                    queryParam.page = currentPage;
                                    window.location.href = `${window.location.pathname}?${qs.stringify(queryParam)}`;
                                }}>show more</SILink>
                            </div> : <div style={{marginTop: '100px'}}></div>
                    }
                </div>
            </section>
        </>)
}

export async function getServerSideProps(context: {
    query: { page: number; searchKeywords: string; mealType: string; recipeType: string; };
    resolvedUrl: string
}) {

    let currentPage = 1;
    let totalItemsCount = 0;
    const itemsCountPerPage = 6;
    let showMore = false;
    const {mealType, recipeType} = context.query;
    if (context.query.page) {
        currentPage = parseInt(String(context.query.page))
    }

    let recipeList: any = []
    let queryObject: any = {
        fields: ["Categories", "Banner_Title", "Link", "Featured"],
        pagination: {
            page: currentPage,
            pageSize: itemsCountPerPage
        },
        filters: {
            Featured: {$eq: false}
        },
        sort: ['id:desc'],
    }

    if (context.query.searchKeywords != undefined) {
        queryObject.filters.Banner_Title = {$containsi: context.query.searchKeywords}
    }
    let orValues = [];
    if (recipeType) {
        let recipeTypeValues = recipeType.split(",")
        for (let i = 0; i < recipeTypeValues.length; i++) {
            orValues.push({
                Categories: {$contains: recipeTypeValues[i]}
            })
        }
    }

    if (mealType) {
        let mealTypeValues = mealType.split(",");
        for (let i = 0; i < mealTypeValues.length; i++) {
            orValues.push({
                Categories: {$contains: mealTypeValues[i]}
            })
        }
    }

    if (orValues.length > 0) {
        queryObject.filters.$or = orValues;
    }

    let queryFeatured = qs.stringify({
        fields: ["Categories", "Banner_Title", "Link", "Featured"],
        filters: {
            Featured: {$eq: true},
        }
    }, {encodeValuesOnly: true,});

    let featuredRecipe = null;
    try {

        for (let i = 1; i <= currentPage; i++) {
            queryObject.pagination.page = i
            let query = qs.stringify(queryObject, {encodeValuesOnly: true});
            const response = await strapi.getRecipeList(query);
            if (response.status == 200 && response.data && response.data.data) {
                showMore = response.data.meta.pagination.page != response.data.meta.pagination.pageCount && response.data.meta.pagination.total > 0
                totalItemsCount = response.data.meta.pagination.total;
                recipeList.push(...response.data.data);
            }
        }

        const responseFeatured = await strapi.getRecipeList(queryFeatured);
        if (responseFeatured.status == 200 && responseFeatured.data && responseFeatured.data.data) {
            if (responseFeatured.data.data.length > 0) {
                featuredRecipe = responseFeatured.data.data[0].attributes;
            }
        }
    } catch (e) {
    }

    const seoDetails = {
        // title: `Recipes | SIDR®`,
        url: context.resolvedUrl,
        // description: 'Make SIDR® honey your favorite ingredient for crafting delicious food—from salad dressings and decadent desserts, to breakfast smoothies and drinks.',
        // keyword: 'honey, desserts, breakfast, smoothies, drinks'
    };

    return {
        props: {
            recipeList,
            currentPage,
            totalItemsCount,
            itemsCountPerPage,
            featuredRecipe,
            showMore,
            mealType: mealType ?? '',
            recipeType: recipeType ?? '',
            searchValue: context.query.searchKeywords ?? null,
            seoDetails
        }
    }
}

export default Recipes;
